import { onMounted, onUnmounted } from "vue";

export const STICKY_PAGE_CONTEXT_CLASS = "financas-sticky-page-context";

let activeContexts = 0;

const addStickyPageContext = () => {
  activeContexts += 1;
  document.body.classList.add(STICKY_PAGE_CONTEXT_CLASS);
};

const removeStickyPageContext = () => {
  activeContexts = Math.max(0, activeContexts - 1);

  if (activeContexts === 0) {
    document.body.classList.remove(STICKY_PAGE_CONTEXT_CLASS);
  }
};

export default function useStickyPageContext() {
  onMounted(addStickyPageContext);
  onUnmounted(removeStickyPageContext);
}
